import { useEffect, useState } from 'react'
import { loadTenantTranslations } from '../lib/i18n'

/**
 * Overlay the session tenant's translation overrides once the slug is known.
 *
 * Returns `true` when the app is ready to render localized copy: either there
 * is no tenant to load (global bundle already loaded at init) or the current
 * tenant's overrides have finished loading. Gating render on this prevents a
 * flash of the global copy before the tenant overrides arrive.
 */
export function useUploadTranslations(
  tenantSlug: string | null | undefined,
): boolean {
  const [loadedSlug, setLoadedSlug] = useState<string | null>(null)

  useEffect(() => {
    if (!tenantSlug) return
    let cancelled = false
    loadTenantTranslations(tenantSlug)
      .catch((err) => console.warn('[i18n] tenant overrides failed:', err))
      .finally(() => {
        if (!cancelled) setLoadedSlug(tenantSlug)
      })
    return () => {
      cancelled = true
    }
  }, [tenantSlug])

  return !tenantSlug || loadedSlug === tenantSlug
}
